import SearchContext from './SearchContext'

const SearchConsumer = SearchContext.Consumer ;

export default SearchConsumer ;